import axios from "axios";

async function getDataFooter() {
  const apiURL = "https://api-ekata.ekata.id/api/footer";

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("Footer : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          id: 1,
          logo_title: "Data Not Found",
          logo_url: "",
          address: "Malang, Indonesia",
        },
      ];
    });
}

async function getDataCompany() {
  const apiURL = "https://api-ekata.ekata.id/api/company";

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("Company : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          id: 1,
          title: "Data Not Found",
          url: "",
        },
      ];
    });
}

async function getDataContactUs() {
  const apiURL = "https://api-ekata.ekata.id/api/contactus";

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("ContactUs : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          id: 1,
          phone_num: "Data Not Found",
          email: "",
        },
      ];
    });
}

export { getDataFooter, getDataCompany, getDataContactUs };
